module.exports = __webpack_public_path__ + "nc_static/media/add-more-role.efa022de.svg";